import { FlyIn, OverlayLoader } from '@coop/components';
import { lazy, Suspense } from 'react';

import { useCncFlyInState } from '../../hooks/useCncFlyInState';
import { CncStep } from '../../store/structureDefinitions/uiState';

const CncStepSwitcher = lazy(() => import('../../../cnc/components/CncStepSwitcher'));

const CncFlyIn = () => {
    const { isOpen, close, afterClose, currentStep } = useCncFlyInState();

    return (
        <FlyIn.Root
            initialFocusOnDialog={false}
            isOpen={isOpen}
            close={close}
            afterClose={afterClose}
            scrollable={currentStep?.step !== CncStep.MiniCart} // minicart handles scroll in it's own way
            className="u-textLeft"
        >
            <Suspense fallback={<OverlayLoader isLoading />}>
                <div
                    data-testid="cnc-step"
                    data-teststep={currentStep?.step}
                    style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <CncStepSwitcher />
                </div>
            </Suspense>
        </FlyIn.Root>
    );
};

export default CncFlyIn;
